<template lang="pug">
transition(name="ed-panel")
  .dawn-panel(@click.stop, v-show="show")
    .dawn-panel-top
      span.close-icon(@click="close")
        i.fal.fa-times
    .dawn-panel-header
      h3.title {{title}}
      p.subtitle {{subtitle}}
    slot(name="body")
    .dawn-panel-footer.text-right
      slot(name="footer")
      div(v-if="!hasSlotFooter")
        ed-button.btn.btn-secondary(@click="close", v-if="secondaryButton != 'false'") {{secondaryButton}}
        ed-button.btn.btn-primary(@click="close", v-if="primaryButton != 'false'") {{primaryButton}}
</template>

<script>

export default {
  name: 'ed-panel',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    primaryButton: {
      type: String,
      default: 'Ok'
    },
    secondaryButton: {
      type: String,
      default: 'Cancel'
    }
  },
  data: function () {
    return {
      body: null,
      footer: null
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.close()
      }
    })
  },
  computed: {
    hasSlotFooter() {
      return this.$slots.footer
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/_variables.scss";

.dawn-panel {
  padding: 1rem 1.5rem;
  background: $canvas;
  box-shadow: $box-shadow;
  position: fixed;
  width: 500px;
  top: 0;
  right: 0;
  margin-top: 0;
  border-radius: 3px 0px 0px 3px;
  z-index: 9999;
  height: 100%;

  h3.title {
    font-weight: $font-weight-extra-bold;
    font-size: $font-size-base-lg;
  }

  p.subtitle {
    font-weight: normal;
    font-size: $font-size-base;
  }
}

.dawn-panel-top {
  text-align: right;
  margin-bottom: -15px;
  
  span.close-icon {
    font-weight: 100;
    color: $ink;
    margin-left: 2rem;
    text-align: right;
    &:hover {
      cursor: pointer;
    }
  }
}

.dawn-panel-body {
  margin: 1rem 0;
}

.text-right {
  text-align: right;
}

.dawn-panel-enter-active, .dawn-panel-leave-active {
  transition: all .6s ease-in-out;
}

.dawn-panel-enter,.dawn-panel-leave-to {
  right: -500px;
}

.dawn-panel-leave,.dawn-panel-enter-to {
  right: 0px;
}

</style>



// WEBPACK FOOTER //
// index.vue?43216480